module.exports = __webpack_public_path__ + "assets/img/per-daaa42f2.png";